import { Expose } from 'class-transformer';

export default class SubmitReviewError {
  review_rating: string[] = []
  review_notes: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}